import { PropsWithChildren } from 'react';
import AppBar from '../../components/shared/AppBar';
import Footer from '../Footer';
import Header from '../Header';
import MainCenter from '../MainCenter';

export default function TemplateCenter({ children }: PropsWithChildren) {
  return (
    <>
      <Header>
        <AppBar />
      </Header>
      <MainCenter>{children}</MainCenter>
      <Footer />
    </>
  );
}
